import reduce from "lodash/reduce";
import { db } from "@/firebase";

export default {
  namespaced: true,
  state: {
    regionDicts: {},
    regionTables: {}
  },
  mutations: {
    updateRegionDict(state, { region, regionDict }) {
      state.regionDicts[region] = regionDict;
    },
    updateRegionDictItem(state, { uid, data }) {
      const { region } = data;
      state.regionDicts[region][uid] = data;
    },
    deleteRegionDictItem(state, { region, uid }) {
      delete state.regionDicts[region][uid];
    },
    updateRegionTable(state, { region, regionDict }) {
      const regionTable = reduce(
        regionDict,
        (acc, data, uid) => {
          const [...list] = acc;
          const item = data;
          item.uid = uid;
          list.push(item);
          return list;
        },
        []
      );

      state.regionTables[region] = regionTable;
    },
    resetRegionDictsAndTables(state) {
      state.regionDicts = {};
      state.regionTables = {};
    }
  },
  actions: {
    async updateRegionDict({ state, commit }, { region, force = false }) {
      try {
        const ref = state.regionDicts[region];

        if (!ref || force) {
          const doc = await db
            .collection("userTables")
            .doc(region)
            .get();
          const data = doc.data();
          const regionDict = reduce(
            data,
            (acc, user, uid) => {
              const { ...dict } = acc;
              dict[uid] = user;
              return dict;
            },
            {}
          );

          commit("updateRegionDict", { region, regionDict });
          commit("updateRegionTable", { region, regionDict });
          return data;
        }
      } catch (e) {
        console.log(e);
        return e;
      }
    },
    updateRegionDictItem({ state, commit }, { uid, data }) {
      const { region } = data;

      // find old item in other region
      const oldRegion = Object.keys(state.regionDicts).find(
        r => r !== region && state.regionDicts[r][uid]
      );

      if (oldRegion) {
        commit("deleteRegionDictItem", { region: oldRegion, uid });
        commit("updateRegionTable", {
          region: oldRegion,
          regionDict: state.regionDicts[oldRegion]
        });
      }

      // update
      commit("updateRegionDictItem", { uid, data });
      commit("updateRegionTable", {
        region,
        regionDict: state.regionDicts[region]
      });
    },
    async updateTableItem({ dispatch }, uid) {
      const doc = await db
        .collection("users")
        .doc(uid)
        .get();

      if (doc.exists) {
        const data = doc.data();
        dispatch("updateRegionDictItem", { uid, data });
      }
    }
  },
  getters: {}
};
